import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentCategoryTypes = ({ location }) => {
  let parms = new URLSearchParams(location.search);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const navigate = useNavigate();
  const [contentCategoryTypeCodes, setcontentCategoryTypeCodes] = useState([]);
  const [state, setState] = useState({
    contentCategoryTypeId: parseInt(parms.get("id")),
    contentCategoryValueCode: 0,
    contentCategoryTypeName: "",
    contentCategoryTypeTitle: "",
    contentCategoryTypeDescr: "",
    contentCategoryTypeCdata: "",
    contentCategoryTypeBdata: "",
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-category-types/${state.contentCategoryTypeId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(
          response.status + ":" + response.data.contentCategoryTypeId
        );

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_CATEGORY_TYPE_CODE`,
        apiHeader(token)
      )
      .then((res) => {
        const contentDescriptorTypeCodes = res.data;
        console.log("results", contentDescriptorTypeCodes);
        setcontentCategoryTypeCodes(contentDescriptorTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });

    console.log("handleOnLoad() - loading id = " + state.contentCategoryTypeId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-category-types/${state.contentCategoryTypeId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentCategoryTypeId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-category-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        navigate(-1);
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
        <h4>Manage Content Category Types</h4>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Selector"
          >
            Content Category Type Selector
          </label>
          <select
            id="contentCategoryTypeId"
            onchange="submit()"
            className="form-control input-xlarge col-sm-8"
            valueChangeListener="#{ombContentCategoryTypeForm.get }"
          >
            <option value="#{ombContentCategoryTypeForm.contentCategoryTypeSelectList}" />
          </select>
        </div>
        <hr />
        <h4>Content Category Type Details</h4>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Name"
          >
            Content Category Type Name
          </label>
          <input
            id="contentCategoryTypeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Title"
          >
            Content Category Type Title
          </label>
          <input
            id="contentCategoryTypeTitle"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeTitle}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Value Code"
          >
            Content Category Type Value Code
          </label>
          <select
            id="contentDescriptorTypeValue"
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorTypeValue}
          >
            <option value={0}>Click to make selection </option>
            {contentCategoryTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Description"
          >
            Content Category Type Description
          </label>
          <textarea
            id="contentCategoryTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeDescr}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type CData"
          >
            Content Category Type CData
          </label>
          <input
            id="contentCategoryTypeCdata"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeCdata}
            onChange={handleChange}
          />
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          Delete
        </button>
        &nbsp;
        <button className="btn btn-success" value="Save" onClick={handleSave}>
          Save
        </button>
        &nbsp;

        {/* <button
          className="btn btn-primary"
          value="Clear"
          actionListener="#{ombContentCategoryTypeForm.clear }"
        >
          Clear
        </button> */}
      </div>
    </form>
  );
};

export default ManageContentCategoryTypes;
